import Fragment from "react";

const DialogText = () => {

  const nl2br = (str) => {
    return str.replace(/\n/g, "<br />");  
  }

  const codes = `
  두써킷 센터 이용 약관
  제1조【목적】
  이 약관은 두써킷센터(이하‘사업자’라 합니다.) 와  두써킷센터가 제공하는 시설 및 서비스를 이용하는 자(이하 ‘이용자’라 합니다) 사이에 체결된 계약에 따른 권리․의무에 관한 사항을 정함을 목적으로 합니다.
  
  제2조【적용대상】
  이 약관은 두써킷 센터 모바일 전용 앱에 회원가입하고 모바일 전용 앱을 이용하는 모든 이용자
  에게 적용됩니다.
  
  제3조【이용계약 및 영업시간】
  1. 이용자가 두써킷 센터를 이용하기 위해서는 모바일 전용 앱을 이용하여 쿠폰구매, 센터 출입, 수업예약 등을 직접 본인이 하여야 합니다. 
  2. 클래스 쿠폰은 횟수와 쿠폰 사용 유효기간이 정해져 있으며 있습니다. 
  3. 두써킷센터 운영시간은 (08:00- 22:00) 이며,  예약 가능한 수업 시간은 모바일 전용 앱에서 확인 할수 있으며 클래스 쿠폰을 이용하여 수업 예약이 가능합니다. 
  
  제4조【게시ㆍ설명의무】
  1. 두써킷센터는 이용자가 용이하게 볼 수 있게 모바일전용앱에 다음사항을 게시하고 있습니다.
     ① 클래스별 프로그램 내용
     ② 지도강사의 경력사항
     ③ 클래스쿠폰 금액과 유효기간
     ④ 약관내용
     ⑤ 소지품 보관 시 유의 사항 
     ⑥ 이용자 안전수칙 등 기타 필요사항   
  
  제5조【이용자 준수 사항】
  1. 이용자는 상호간의 위화감 조성 및 전염병, 풍기문란, 음주 등으로 질서유지에 지장을 초래할 
     경우 이용자의 권리를 제한 및 박탈 할 수 있습니다. 
  2. 이용자는 모바일 전용 앱을 사용하지 않고 출입을 할 수 없습니다. 
  3. 이용자가 두써킷 센터 이용자가 아닌 자를 동반 출입시켜 시설을 이용 하는 경우, 이용자 및 이용자가 아닌 자에게 모두 민법상 일일 이용금액의 최고 50배를 부과 합니다. 
  
  제 6조【클래스쿠폰 예약 취소】
  1. 이용자가 예약한 클래스 쿠폰의 취소는 모바일 전용 앱의 내예약 페이지에서 취소하고 재신청이 가능합니다. 
  2. 예약한 클래스 쿠폰의 수업을 불가항력적인 사유로 참석하지 못했을 때 관련 증명 서류를 
     지참하면  클래스 쿠폰 반환 신청이 가능 합니다. 
  3. 불가항력적인 사유로는 천재지변, 사고, 질병, 보고 등 증빙서류 제출인 가능한 사유입니다.
  4. 예약 완료된 쿠폰은 예약일 24시간 이내에 예약 취소가 가능합니다. 
  
  
  
  제7조【클래스쿠폰 환불 신청】
  1. 이용자는 구매 후 미사용한 클래스 쿠폰을 쿠폰 유효기간 만료일 전까지 환불 신청을 할 
     수 있습니다.
  2. 이용자는 모바일 전용 앱을 이용하여 직접 환불 신청을 하여야 합니다. 
  3. 미사용 클래스 쿠폰은 잔여일 하루당 1개의 쿠폰만 계약 해제 해지 가능 합니다. 
     (1일 1쿠폰 인정)
  4. 이용자 사정으로 클래스쿠폰을 환불 하는 경우 사업자는 할인적용 전 금액(1회권 30,000원)을
     기준으로 쿠폰의 유효기간까지 사용한 클래스쿠폰의 해당한 금액과 최초 구매쿠폰 전체금액의
     10%에 해당 하는 금액을 공제한 후 이용자에게 환불합니다.
  5. 예시를 들면 최초쿠폰 결제금액 100,000원 4회권 구매 후 2회사용 유효기간 1일 남은경우
     ① 10% 해당 환불수수료 10,000원 
       (재정경제부 제정 소비자피해보상규정 제3조 별표2 제20항에 의거함)
     ② 사용쿠폰공제 1회권 30,000원  2회사용금액  60,000원
       (최초 100,000원 쿠폰 17% 할인 받아 구매하였으므로 공제 할때는 약관 규정에 따라 1회권
        30,000원으로 공제 함)
     ③ 환불 불가 쿠폰  1회권 30,000원  (1일 1쿠폰만 환불 가능 )
     ④ 최종 환불 금액은  0원입니다. 
     ⑤ 계산식 “100,000원 – 10,000원(10%환불수수료) - 60,000원(2회사용금액쿠폰금액) - 
        30,000원(환불불가쿠폰금액)  = 환불금액  0 원 
  
  제7조-1항 【클래스정기권  환불 신청】
  1. 이용자는 구매 후 정기권 유효기간 만료일 전까지 환불 신청을 할  수 있습니다.
  2. 이용자는 모바일 전용 앱을 이용하여 직접 환불 신청을 하여야 합니다. 
  3. 이용자 사정으로 정기권을 환불 하는 경우 사업자는 할인적용 전 금액(1일  30,000원)을
     기준으로 정기권의 사용기간에  해당한 금액과 최초 구매쿠폰 전체금액의
     10%에 해당 하는 금액을 공제한 후 이용자에게 환불합니다.
  
  제8조【손해배상】
  1. 이용자의 고의ㆍ중대한 과실로 두써킷센터의 기기의 파손 등 두써킷 센터의 손해가 발생한 경우 이용자는 이를 배상하여야 합니다.
  2. 이용자 본인 부주의로 인한 상해 발생시나  이용자의 병력이나 기타 사유로 인한 상해 발생시  두써킷 센터에서는 책임을 지지 않습니다.
  3. 이용자가 맡기시지 않은 귀중품 분실에 대해서는 본 두써킷센터에서는 책임을 지지않습니다.
  
  제 9 조【센터 이용중지】
  1. 사업자는 천재지변이나 기타 불가항력의 사유로 두써킷 센터 이용이 곤란한 때에는 해당 사유가 종료될 때까지 이용을 중단시킬 수 있습니다.
  2. 사업자가 영업일(토.일.공휴일.기타휴일 제외) 이용을  중지할때는 이용가능 기간을 중단된 영업일 만큼 연장 해 주도록 합니다.
  
  제10조【탈의실 이용안내】
  1. 탈의실내 사물함에 있는 물품 등은 키를 사용하여 이용자가 직접 관리 하여야 합니다. 
     사물함 키 분실시 삼만원 (30,000원)의 비용이 발생 합니다. 
     사물함 도난 사고는 사업자가 책임을 지지 않습니다.)
  2. 탈의실 내에는 개인 물건을 장기보관 하실 수 없습니다. 
     찾아가지 않는 개인 물품은 익일이후  모두 페기 처분 합니다. 
  
  제11조【기타】
  1. 이 약관에서 규정하지 않은 사항은 관계법령 및 거래 관행을 고려하여 신의원칙에 따라 사업자와 이용자가 합의하여 해결합니다.
  2. 이 약관과 관련된 소송의 관할법원은 민사소송법상의 관련규정에 의합니다.  
  `;

  return <div dangerouslySetInnerHTML={{__html: nl2br(codes)}}></div>


};

export default DialogText;